import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import React, { useEffect, useState, useRef } from 'react';
import { callApi } from "../../common/api";
import CustomizedSnackbars from "../alert/alert";

function ReactCmsEditor() {
  const quillRef = useRef(null);
  const [content, setContent] = useState('');
  const [snackBarMsg, setSnackBarMsg] = useState({
    message: "",
    severity: "success",
    open: false,
  });

  const handleInsertImage = () => {
    const url = window.prompt('Enter the image URL:');
    if (url) {
      const editor = quillRef.current.getEditor();
      const range = editor.getSelection();
      if (range) {
        editor.insertEmbed(range.index, 'image', url, 'user');
        editor.setSelection(range.index + 1);
      } else {
        editor.insertEmbed(editor.getLength(), 'image', url, 'user');
        editor.setSelection(editor.getLength() - 1);
      }
    }
  };

  const handleImageClick = () => {
    handleInsertImage();
  };

  const getEditorContent = async () => {
    try {
      const response = await callApi("get", "startup/getStartupProfile");
      if (response.data.status) {
        setSnackBarMsg({
          message: response.data.message,
          severity: "success",
          open: true
        })
      }
     
      return response.data.data[0].startUpInfo.resources.htmlContent;
    } catch (error) {
      console.log(error)
      if (error.response) {
        // The request was made, but the server responded with an error status
        setSnackBarMsg({
          message: error.response.data.message,
          severity: "error",
          open: true,
        });
        // You can handle specific HTTP error codes here if needed
      } else if (error.request) {
        // The request was made, but no response was received
        setSnackBarMsg({
          message: "An error occurred while processing your request.",
          severity: "error",
          open: true,
        });
      } else {
        // Something happened in setting up the request that triggered an Error
        setSnackBarMsg({
          message: error.message,
          severity: "error",
          open: true,
        });
      }
    }

  }

  useEffect(() => {
    getEditorContent().then((v) => {
      setContent(v);
    });
  }, []);

  const handleClick = async (e) => {
    let htmlContent = content;
    let obj = {
      resources: JSON.stringify({
        htmlContent
      })
    }
    const response = await callApi("post", "startup/startupProfile", obj);
  };

  const handleContentToPost = (e) => {
    setContent(e)
  }

  const modules = {
    toolbar: {
      container: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ align: [] }],
        ['link', 'image'],
        [{ list: 'ordered' }, { list: 'bullet' }],
        ['blockquote', 'code-block'],
        [{ color: [] }, { background: [] }],
        ['clean'],
      ],
      handlers: {
        image: handleImageClick,
      },
    },
  };


  return (
    <div>
      <ReactQuill
        // ref={quillRef}
        // modules={modules}
        onChange={handleContentToPost}
        value={content}
      />
      <button onClick={handleClick}>Submit</button>
      <CustomizedSnackbars
        msgData={snackBarMsg}
        setMsgData={setSnackBarMsg}
      />
    </div>
  );
}

export default ReactCmsEditor;
